import { useCallback, useEffect, useMemo, useState } from 'react';
import api from '../utils/axiosConfig';

export default function useCompanyFilter(initialCompanyId) {
  const [companies, setCompanies] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState('');
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get('/companies')
      .then((response) => {
        const sorted = [...response.data].sort((a, b) => a.id - b.id);
        setCompanies(sorted);

        if (initialCompanyId !== undefined) {
          setSelectedCompanyId(initialCompanyId ? String(initialCompanyId) : '');
          return;
        }

        if (sorted.length > 0) {
          setSelectedCompanyId(String(sorted[0].id));
        }
      })
      .catch((error) => {
        console.error('Error fetching companies:', error);
      })
      .finally(() => {
        setLoaded(true);
      });
  }, [initialCompanyId]);

  const handleCompanyChange = useCallback((event) => {
    setSelectedCompanyId(event.target.value);
  }, []);

  const companyQueryParam = useMemo(
    () => (selectedCompanyId ? { companyId: Number(selectedCompanyId) } : {}),
    [selectedCompanyId]
  );

  return {
    companies,
    selectedCompanyId,
    setSelectedCompanyId,
    handleCompanyChange,
    companyQueryParam,
    companiesLoaded: loaded,
  };
}
